import React from 'react';
import { IconSVG } from '../IconSVG';
import './NotAuthorised.scss';
export const NotAuthorised = () => (React.createElement("div", { className: "notauthorised-content-wrapper" },
    React.createElement("div", { className: "notauthorised-content" },
        React.createElement(IconSVG, { iconType: "ErrorIcon", style: { width: '48px', height: '48px' } }),
        React.createElement("h1", { className: "notauthorised-title" }, "Access Denied"),
        React.createElement("p", null, "You are not authorized to access this page"))));
//# sourceMappingURL=NotAuthorised.js.map